import React, { useState } from 'react';
import { PUBLIC_CONTACT_EMAIL } from '../../constants/landingPublicContact';
import styles from './Terms.module.css';

interface TermsProps {
  className?: string;
}

const Terms: React.FC<TermsProps> = ({ 
  className = '' 
}) => {
  const [showModal, setShowModal] = useState(false);

  const handleLinkClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setShowModal(true);
  };

  const closeModal = () => {
    setShowModal(false);
  };

  return (
    <>
      <div className={className}>
        <a 
          href="#"
          onClick={handleLinkClick}
          style={{ 
            color: '#fff', 
            textDecoration: 'none', 
            fontSize: '0.95rem',
            lineHeight: '1'
          }}
        >
          Terms & Conditions
        </a>
      </div>

      {showModal && (
        <div className={styles.modalOverlay} onClick={closeModal}>
          <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
            <div className={styles.modalHeader}>
              <h2>Terms & Conditions for Tranzit.io</h2>
              <button 
                className={styles.closeButton}
                onClick={closeModal}
                aria-label="Close"
              >
                ×
              </button>
            </div>
            
            <div className={styles.modalBody}>
              <div className={styles.section}>
                <p><strong>Effective Date:</strong> April 2025</p>
                
                <p>
                  These Terms & Conditions ("Terms") govern access to and use of the Tranzit.io platform, including the website,
                  applications, APIs, and related services (collectively, the "Platform"). The Platform is owned and operated by SMR
                  Consulting LLC, doing business as Tranzit.io, located in Houston, Texas ("Tranzit," "we," "us," or "our"). By
                  accessing or using the Platform, you agree to be bound by these Terms.
                </p>

                <h3>1. Eligibility and Account Registration</h3>
                <p>
                  You must be at least eighteen (18) years old to use the Platform. You are responsible for maintaining accurate account
                  information and all activity under your account.
                </p>

                <h3>2. Description of the Platform</h3>
                <p>
                  Tranzit provides a logistics visibility, discovery, and workflow platform. Tranzit is not a motor carrier, freight broker,
                  freight forwarder, or shipper. All transportation arrangements are made solely between users.
                </p>

                <h3>3. AI-Assisted Features</h3>
                <p>
                  AI-generated outputs are informational only and may contain errors. Users are responsible for verifying results. Tranzit
                  is not liable for reliance on AI outputs.
                </p>

                <h3>4. Billing, Subscriptions, and Fees</h3>
                <p>
                  Subscriptions renew automatically unless canceled. Fees are nonrefundable except where required by law. Tranzit
                  does not hold or process freight payments.
                </p>

                <h3>5. User Content</h3>
                <p>
                  You retain ownership of your content and grant Tranzit a limited license to process content solely to operate the
                  Platform.
                </p>

                <h3>6. Platform Availability</h3>
                <p>
                  The Platform is provided "as available." Features may change or be discontinued at any time.
                </p>

                <h3>7. Third-Party Services</h3>
                <p>
                  Tranzit is not responsible for third-party services or outages.
                </p>

                <h3>8. Prohibited Conduct</h3>
                <p>
                  You may not misuse, interfere with, reverse engineer, or use the Platform unlawfully.
                </p>

                <h3>9. Disclaimers</h3>
                <p>
                  THE PLATFORM IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND.
                </p>

                <h3>10. Limitation of Liability</h3>
                <p>
                  Liability is limited to amounts paid in the prior twelve (12) months. No liability for indirect or consequential damages.
                </p>

                <h3>11. Indemnification</h3>
                <p>
                  You agree to indemnify SMR Consulting LLC (DBA Tranzit.io) from claims arising from your use of the Platform.
                </p>

                <h3>12. Termination</h3>
                <p>
                  Access may be suspended or terminated for violations, nonpayment, or legal concerns.
                </p>

                <h3>13. Governing Law</h3>
                <p>
                  These Terms are governed by Texas law. Arbitration shall occur in Houston, Texas.
                </p>

                <h3>14. Contact Information</h3>
                <p>
                  Email: {PUBLIC_CONTACT_EMAIL}<br />
                  Houston, Texas, United States
                </p>

                <h3>15. Changes</h3>
                <p>
                  Continued use constitutes acceptance of updated Terms.
                </p>
              </div>
            </div>
            
            <div className={styles.modalFooter}>
              <button 
                className={styles.closeButtonFooter}
                onClick={closeModal}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Terms;






